import { useState, useRef, useCallback } from 'react';

interface UseTableSearchResult {
  /** Debounced value — pass this to the API/filter. */
  searchValue: string;
  /** Immediate value — bind this to the input. */
  inputValue: string;
  setInputValue: (v: string) => void;
  clearSearch: () => void;
}

export function useTableSearch(delayMs = 400): UseTableSearchResult {
  const [inputValue, setInputRaw] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

  const setInputValue = useCallback(
    (v: string) => {
      setInputRaw(v);
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setSearchValue(v), delayMs);
    },
    [delayMs],
  );

  const clearSearch = useCallback(() => {
    if (timer.current) clearTimeout(timer.current);
    setInputRaw('');
    setSearchValue('');
  }, []);

  return { searchValue, inputValue, setInputValue, clearSearch };
}
